export const AUTH_CONFIG = {
  INACTIVITY_TIMEOUT_HOURS: 2.0, // Default to 2 hours
};
